// extracted by mini-css-extract-plugin
module.exports = {"mark":"general_mark__24bbq","great":"general_great__2oBxw"};